import { api } from './client';
import { ExternalAsset } from '../types/entities/external-asset.entity';
import {
    ExternalAssetRequest,
    ExternalAssetResponse,
    ExternalAssetsCatalogResponse,
} from '../types/responses/external-assets.responses';

export const externalAssetService = {
    getCatalog: async (options?: { limit?: number }): Promise<ExternalAsset[]> => {
        const limit = options?.limit;
        const suffix =
            limit != null && limit > 0
                ? `?limit=${encodeURIComponent(String(limit))}`
                : '';
        const response = await api.get<ExternalAssetsCatalogResponse>(
            `/external-assets/catalog${suffix}`,
        );
        return response.data.data.assets;
    },

    create: async (payload: ExternalAssetRequest): Promise<ExternalAsset> => {
        const response = await api.post<ExternalAssetResponse>('/external-assets', payload);
        return response.data.data.asset;
    },

    update: async (id: string, payload: ExternalAssetRequest): Promise<ExternalAsset> => {
        const response = await api.put<ExternalAssetResponse>(`/external-assets/${id}`, payload);
        return response.data.data.asset;
    },

    delete: async (id: string): Promise<void> => {
        await api.delete(`/external-assets/${id}`);
    },
};
